import { render, staticRenderFns } from "./IndexTxt.vue?vue&type=template&id=d8e30d4e&"
import script from "./IndexTxt.vue?vue&type=script&lang=js&"
export * from "./IndexTxt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports